import React from 'react';
import ReactDOM from 'react-dom/client';
/* Reihenfolge der Stylesheets:
     1. design-system v3 — Token UND Bauteilklassen (.app-shell, .btn, .card,
        .page …). v3/base.css zieht compat/v2-aliases.css selbst mit, die
        v2-Namen in styles.css (--glass-bg, --muted …) loesen also weiter auf.
     2. die App.
   Hier stand '@weretradeit/ui-react/src/styles.css'. 4.2.1 liefert kein src/
   mehr (nur dist/, und gar kein CSS) — die Zeile haette den Bau gebrochen.
   ui-react zieht dasselbe base.css selbst herein; der Import hier ist die
   Zusage der App, dass es auch ohne ein einziges Bauteil geladen ist. Vite
   gibt es einmal aus.

   Die Szene `wt-glyphfield.neuralWhale.js` steht BEWUSST NICHT hier: App.tsx
   laedt sie nach dem Einhaengen im Leerlauf (glyphScene.ts). */
import '@weretradeit/design-system/v3/base.css';
import { ErrorBoundary } from '@weretradeit/ui-react';
import App from './App';
import './styles.css';
import './styles/flow-diagram.css';

/* Die aeussere Fehlergrenze um die Wurzel: `appKey`, OHNE `fallback` (ein
   `fallback` gewaenne vor `appKey`). Sie faengt, was die innere Grenze in
   App.tsx nicht sieht — einen Fehler in der Huelle selbst — und zeigt dann
   `GlyphErrorPage kind="500"` statt einer leeren Seite. */
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary appKey="neuralWhale">
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);
